export interface ProductParagraphInfo {
    productParagraphId: number;
    paragraphId: number;
    paragraphText: string;
}
